import { Button, Grid, Typography } from '@mui/material';
import { useIsMobile } from '@side/pantry';
import { kebabCase, snakeCase } from 'lodash';
import NextLink from 'next/link';
import type { QuickLink } from '@/views/Home/hooks/useQuickLinksSection/types';
import {
  TrackHomePageEvent,
  useTrackHomePageAnalytics,
} from '$analytics/useTrackAnalytics/domains/homePage';
import { QuickLinkCircle } from './QuickLinkCircle';

export const QuickLinkButton = ({
  href,
  title,
  iconLarge: Icon,
  iconSmall: MobileIcon,
  isInternalLink,
}: QuickLink) => {
  const trackEvent = useTrackHomePageAnalytics();
  const isMobile = useIsMobile('md');
  const externalLinkProps = {
    rel: 'noopener noreferrer',
    target: '_blank',
  };
  const internalLinkProps = {
    LinkComponent: NextLink,
  };

  return (
    <Grid
      size={1}
      sx={{
        display: 'flex',
        justifyContent: { xs: 'start', md: 'center' },
      }}
    >
      <Button
        id={`quick-link-${kebabCase(title)}`}
        aria-label={title}
        href={href}
        sx={{
          flexDirection: { xs: 'row', md: 'column' },
          gap: 1,
          px: { xs: 0.5, sm: 2 },
        }}
        onClick={() => {
          trackEvent(TrackHomePageEvent.QuickLinkClick, {
            eventTarget: snakeCase(title),
          });
        }}
        {...(isInternalLink ? internalLinkProps : externalLinkProps)}
      >
        <QuickLinkCircle>{isMobile ? MobileIcon : Icon}</QuickLinkCircle>
        <Typography
          variant={isMobile ? 'caption' : 'subtitle2'}
          component="span"
          sx={{
            textAlign: { xs: 'left', md: 'center' },
            color: 'text.secondary',
          }}
        >
          {title}
        </Typography>
      </Button>
    </Grid>
  );
};
